import TextureLayer from './TextureLayer';
import ImageTextureLayer from './ImageTextureLayer';
import MaskTextureLayer from './MaskTextureLayer';
import ColorTextureLayer from './ColorTextureLayer';
import TextTextureLayer from './TextTextureLayer';

class TextureLayerFactory {
  private typeToLayer = {
    mask: MaskTextureLayer,
    basic: ColorTextureLayer,
    color: ColorTextureLayer,
    logo: ColorTextureLayer,
    text: TextTextureLayer,
    image: ImageTextureLayer,
  };
  private readonly type: string;
  private readonly argsToComp: any;

  constructor(type: string, argsToComp) {
    this.type = type;
    this.argsToComp = argsToComp;
  }

  getLayerComponent() {
    return this.typeToLayer[this.type] ? new this.typeToLayer[this.type](this.argsToComp) : new TextureLayer(this.argsToComp);
  }
}

export {
  MaskTextureLayer,
  ImageTextureLayer,
  ColorTextureLayer,
  TextTextureLayer,

  TextureLayerFactory
}